module.exports = __webpack_public_path__ + "img/image_2.0722938f.png";